import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import {
    MarketdateService,
    MarketdatePopupService,
    MarketdateComponent,
    MarketdateDetailComponent,
    MarketdateDialogComponent,
    MarketdatePopupComponent,
    MarketdateDeletePopupComponent,
    MarketdateDeleteDialogComponent,
    marketdateRoute,
    marketdatePopupRoute,
    MarketdateResolvePagingParams,
} from './';

const ENTITY_STATES = [
    ...marketdateRoute,
    ...marketdatePopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        MarketdateComponent,
        MarketdateDetailComponent,
        MarketdateDialogComponent,
        MarketdateDeleteDialogComponent,
        MarketdatePopupComponent,
        MarketdateDeletePopupComponent,
    ],
    entryComponents: [
        MarketdateComponent,
        MarketdateDialogComponent,
        MarketdatePopupComponent,
        MarketdateDeleteDialogComponent,
        MarketdateDeletePopupComponent,
    ],
    providers: [
        MarketdateService,
        MarketdatePopupService,
        MarketdateResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerMarketdateModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate/marketdate.module.ts